const EmailScheduler = ()=>{
    return (
        <div>Email Scheduler</div>
    )
}
export default EmailScheduler